import { render, staticRenderFns } from "./ImmobilePatrimonioModal.vue?vue&type=template&id=5dfaa692&scoped=true&"
import script from "./ImmobilePatrimonioModal.vue?vue&type=script&lang=js&"
export * from "./ImmobilePatrimonioModal.vue?vue&type=script&lang=js&"
import style0 from "./ImmobilePatrimonioModal.vue?vue&type=style&index=0&id=5dfaa692&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfaa692",
  null
  
)

component.options.__file = "ImmobilePatrimonioModal.vue"
export default component.exports